let config = {};
if (window.tsc) {
    config = window.tsc.config;
}
else {
    // todo: would be nice to log this
    // eslint-disable-next-line no-console
    console.log('Could not load config');
}
export default Object.freeze(config);
